export default "__VITE_ASSET__0otCk0Hi__"